/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import Imgix from 'js/components/Imgix';

import { Grid, Typography2 } from '@coursera/cds-core';
import { useTracker } from '@coursera/event-pulse/react';

import {
  getLandingPageLink,
  logo,
  numberOfProductsWithPlusSign,
} from 'bundles/coursera-plus-common/utils/courseraPlusUtils';

import _t from 'i18n!nls/coursera-plus';

const styles = {
  container: css`
    width: 100%;
    padding: var(--cds-spacing-100) var(--cds-spacing-100);
    margin: 0;
  `,
  plusLogo: css`
    margin-left: 2px;
  `,
  buttonText: css`
    color: var(--cds-color-interactive-primary);
  `,
  wrapper: css`
    border-bottom: 1px solid var(--cds-color-neutral-stroke-primary-weak);
    border-top: 1px solid var(--cds-color-neutral-stroke-primary-weak);
    margin-top: var(--cds-spacing-100);
    padding: var(--cds-spacing-100) 0;
  `,
};

const CourseraPlusButton = () => {
  const track = useTracker();

  return (
    <a
      href={getLandingPageLink()}
      onClick={() => {
        track('click_button', {
          button: { name: 'c_plus_learn_more' },
          pageSection: { sectionName: 'page_header_popup_menu' },
        });
      }}
      role="menuitem"
    >
      <Grid container direction="column" alignItems="center" css={styles.container}>
        <Grid item container direction="column">
          <Grid item container justifyContent="space-between" alignItems="center" wrap="nowrap">
            <Grid item container alignItems="center">
              <Grid item>
                <Typography2 variant="actionPrimary" component="p" css={styles.buttonText}>
                  {_t('Get Coursera')}
                </Typography2>
              </Grid>
              <Grid item css={{ display: 'inline-flex' }}>
                <Imgix
                  src={logo.PLUS_PILL_BLUE}
                  alt={_t('Coursera Plus')}
                  maxWidth={32}
                  maxHeight={12}
                  css={styles.plusLogo}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Typography2 variant="bodySecondary" component="p">
              {_t('Access #{numberOfCourses} courses', { numberOfCourses: numberOfProductsWithPlusSign })}
            </Typography2>
          </Grid>
        </Grid>
      </Grid>
    </a>
  );
};

export default CourseraPlusButton;
